import React from "react";

export default function ProofPreview({ proof }) {
  if (!proof?.photoUrl) return null;

  return (
    <section className="rounded-2xl bg-[#0b1727] p-4">
      <div className="text-xs uppercase tracking-[0.2em] text-slate-500">Delivery Proof</div>
      <div className="mt-3 overflow-hidden rounded-2xl border border-white/10 bg-white/5">
        <img
          src={proof.photoUrl}
          alt="Delivery proof"
          className="block max-h-[280px] w-full object-cover"
        />
      </div>
      <div className="mt-3 space-y-1 text-sm text-slate-300">
        {proof.deliveredBy ? <div><span className="text-slate-500">Delivered by:</span> <span className="text-white">{proof.deliveredBy}</span></div> : null}
        {proof.receiverName ? <div><span className="text-slate-500">Received by:</span> <span className="text-white">{proof.receiverName}</span></div> : null}
        {proof.note ? <div><span className="text-slate-500">Note:</span> <span className="text-white">{proof.note}</span></div> : null}
      </div>
    </section>
  );
}
